import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';
declare var lightGallery: any;
@Component({
  selector: 'app-register-dance-event',
  templateUrl: './register-dance-event.component.html',
  styleUrls: ['./register-dance-event.component.scss']
})
export class RegisterDanceEventComponent implements OnInit {

  //add user form start
  registerForm: FormGroup;
  submitted = false;
  router: any;
  key: any;
  constructor(public fb: FormBuilder, private http: HttpClient, private _router: Router) {
    this.registerForm = this.fb.group({
      studentName: ['', [Validators.required]],
      age: ['', [Validators.required]],
      phone: [''],
      email: ['', [Validators.required]],
      parentNo: [''],
      parentEmail: [''],
      collegeName: [''],
      city: ['', [Validators.required]],
      eventTime: [''],
      centerName: [''],
      message: [''],
    })
  }
  //^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$
  get f() { return this.registerForm.controls; }
  //Add user form actions
  submitForm() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }


    var formData: any = new FormData();
    formData.append("studentName", this.registerForm.value.studentName);
    formData.append("age", this.registerForm.value.age);
    formData.append("phone", this.registerForm.value.phone);
    formData.append("email", this.registerForm.value.email);
    formData.append("parentNo", this.registerForm.value.parentNo);
    formData.append("parentEmail", this.registerForm.value.parentEmail);
    formData.append("collegeName", this.registerForm.value.collegeName);
    formData.append("city", this.registerForm.value.city);
    formData.append("eventTime", this.registerForm.value.eventTime);
    formData.append("centerName", this.registerForm.value.centerName);
    formData.append("message", this.registerForm.value.message);



    console.log(formData);

    this.http.post('https://ghrscf.com/includes/register-dance-event.php', formData).subscribe(
      (response) => console.log(response),
      (error) => console.log(error)
    );
    //this.router.navigate(['/demo']);
    this._router.navigateByUrl('/thank-you');
    //this._router.navigateByUrl('/payment-form')
  }


  ngOnInit(): void {
  }
  ngAfterViewInit() {
    /*---------------------------
    :: lightBox Gallery
    -----------------------------*/
    let galerias = document.getElementsByClassName('video-gallery');
    for (let i = 0; i < galerias.length; i++) {
      galerias[i].id = 'gal' + i;
      lightGallery(document.getElementById('gal' + i), {
        selector: 'a',
      });
    }

    let gall_image = document.getElementsByClassName('lightgallery');
    for (const gal of gall_image) {
      lightGallery(gal), {
        selector: 'a',
      }
    }

  }

}
